<template>
	<div class="banner">
		<div v-if="false" class="advisory">
			<h5>“家庭训练师”在线与您</h5>
			<h1 style="margin-top: 15px;">共同监护孩子视觉康复</h1>
			<h6>已解决10000个患者视觉康复问题</h6>
			<h6>原价：<span style="text-decoration: line-through;color: #ffb805;">400</span>元/月 现价：<span style="color: #f00;">5.99</span>元/月</h6>
			<div class="btn">
				<button @click="toService">立即咨询<i></i></button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		methods: {
			// 点击立即咨询
			toService() {
				this.$router.push({path: '/index/service'});
			}
		}
	}
</script>

<style scoped>
	.banner{ position: relative;height: 400px;background-image: url(../../../../assets/download_banner.png);background-repeat: no-repeat;background-position: center center; }
	.banner .advisory{ position: absolute;width: 512px;height: 250px;top: 50%;left: 50%;margin: -125px 0 0 -256px;padding: 30px 20px 0 20px;background: rgba(0, 0, 0, 0.65); }
	.banner h5{ font-size: 16px;color: #fff;text-align: center;line-height: 24px; }
	.banner h1{ font-size: 40px;color: #fff;text-align: center;line-height: 44px; }
	.banner h6{ color: #fff;text-align: center;line-height: 24px; }
	.banner .btn{ margin-top: 15px;text-align: center; }
	.banner button{ width: 164px;height: 46px;font-size: 22px;line-height: 46px; }
	.banner i{ display: inline-block;width: 18px;height: 20px;margin: 13px 0 0 10px;background-image: url(../../../../assets/double_right_arrow.png);background-size: 100% 100%;vertical-align: top; }
</style>
